"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.ControlBar = void 0;
var React = __importStar(require("react"));
var play_toggle_control_1 = require("./controls/play-toggle-control");
var volume_menu_button_control_1 = require("./controls/volume-menu-button-control");
var current_time_display_1 = require("./time-controls/current-time-display");
var time_divider_1 = require("./time-controls/time-divider");
var duration_display_1 = require("./time-controls/duration-display");
var playback_rate_menu_button_control_1 = require("./controls/playback-rate-menu-button-control");
var fullscreen_toggle_control_1 = require("./controls/fullscreen-toggle-control");
var side_panel_toggle_control_1 = require("./controls/side-panel-toggle-control");
var closed_captions_menu_button_control_1 = require("./controls/closed-captions-menu-button-control");
var ControlBar = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "cueplayer-react-control-bar" },
        React.createElement("div", { className: "cueplayer-react-control-bar-left-part" },
            React.createElement(play_toggle_control_1.PlayToggleControl, null),
            React.createElement(playback_rate_menu_button_control_1.PlaybackRateMenuButtonControl, null),
            React.createElement(volume_menu_button_control_1.VolumeMenuButtonControl, null)),
        React.createElement("div", { className: "cueplayer-react-control-bar-center-part" },
            React.createElement(current_time_display_1.CurrentTimeDisplay, null),
            React.createElement(time_divider_1.TimeDivider, null),
            React.createElement(duration_display_1.DurationDisplay, null)),
        React.createElement("div", { className: "cueplayer-react-control-bar-right-part" },
            children,
            React.createElement(closed_captions_menu_button_control_1.ClosedCaptionsMenuButtonControl, null),
            React.createElement(side_panel_toggle_control_1.SidePanelToggleControl, null),
            React.createElement(fullscreen_toggle_control_1.FullscreenToggleControl, null))));
};
exports.ControlBar = ControlBar;
